import script from "./ModalSave.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalSave.vue?vue&type=script&setup=true&lang=ts"

import "./ModalSave.vue?vue&type=style&index=0&id=40396816&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40396816"]])

export default __exports__